import React, { useEffect, useState } from "react"
import { Link } from "gatsby"

import logoImg from "../images/logo.svg"
import heaerLogo from "../images/logo-header.svg"
import menu_arrow from "../images/icon-white_arrow.svg"
import CvButton from "./cvbutton"
import Scroll from "./scroll"

import twitterIcon from "../images/icon-twitter.svg"
import facebookIcon from "../images/icon-facebook.svg"
import instagramIcon from "../images/icon-instagram.svg"
import youtubeIcon from "../images/icon-youtube.svg"

const Layout = ({ location, children }) => {
  const rootPath = `${__PATH_PREFIX__}/`
  const isRootPath = location.pathname === rootPath

  const [isMenuOpen, setMenuOpen] = useState(false)

  const menuItems = [
    { label: "フードデリバリーのメリット", path: "/merit" },
    {
      label: "出前館の強み",
      path: "/advantage",
      subItems: [{ label: "選べる配達プラン", path: "/advantage/plan" }],
    },
    { label: "出店費用", path: "/cost" },
    { label: "出店の流れ", path: "/start-guide" },
    { label: "事例紹介", path: "/cases" },
    { label: "よくある質問", path: "/faq" },
  ]

  const [hasScrolled, setHasScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      const yOffset = window.scrollY
      if (!isMenuOpen) {
        if (yOffset > 10) {
          setHasScrolled(true)
        } else {
          setHasScrolled(false)
        }
      }
    }
    window.addEventListener("scroll", handleScroll)
    return () => {
      window.removeEventListener("scroll", handleScroll)
    }
  }, [isMenuOpen])

  const scrolledClass = hasScrolled ? "scrolled" : ""
  const rootClass = isRootPath ? "root-path" : ""
  const menuOpenClass = isMenuOpen ? "open" : ""

  useEffect(() => {
    const rootStyle = document.documentElement.style
    if (isMenuOpen) {
      rootStyle.overflow = "hidden"
    } else {
      rootStyle.overflow = "auto"
    }
    return () => {
      rootStyle.overflow = "auto"
    }
  }, [isMenuOpen])

  const isThirdLevelOrDeeperAndMatchSecondLevel = (currentPath, itemPath) => {
    const currentParts = currentPath.split("/").filter(Boolean)
    const itemParts = itemPath.split("/").filter(Boolean)
    // 第3階層以上が存在するかチェック
    if (currentParts.length >= 3) {
      return currentParts[currentParts.length - 2] === itemParts[0]
    }
    return false
  }

  return (
    <div className="global__wrapper" data-is-root-path={isRootPath}>
      <header
        className={`header ${rootClass} ${scrolledClass} ${menuOpenClass}`}
      >
        <div className="header__content">
          <div className="header__logo">
            <Link to="/">
              <img src={heaerLogo} alt="出前館ロゴ" />
            </Link>
          </div>
          <div className="header__group">
            <ul className={`header__nav ${menuOpenClass}`}>
              {menuItems.map(item => (
                <li
                  key={item.label}
                  className={
                    isThirdLevelOrDeeperAndMatchSecondLevel(
                      location.pathname,
                      item.path
                    )
                      ? "subitem"
                      : ""
                  }
                >
                  <Link to={item.path}>{item.label}</Link>
                </li>
              ))}
            </ul>
            <div
              className={`header__menu_btn ${menuOpenClass}`}
              onClick={() => setMenuOpen(!isMenuOpen)}
            >
              <div className="header__menu_lines">
                <span></span>
                <span></span>
              </div>
              <p>{isMenuOpen ? "CLOSE" : "MENU"}</p>
            </div>
          </div>
        </div>
      </header>
      <nav className={`hamburger-menu ${menuOpenClass}`}>
        <div
          className="hamburger-menu__overlay"
          onClick={() => setMenuOpen(!isMenuOpen)}
        ></div>
        <div className="hamburger-menu__wrapper">
          <div className="hamburger-menu__container">
            {menuItems.map(item =>
              item.subItems ? (
                <div className="hamburger-menu__item01" key={item.label}>
                  <div className="hamburger-menu__label">
                    <Link className="c_link_animation" to={item.path}>
                      {item.label}
                      <span className="c_link_animation__arrow">
                        <img src={menu_arrow} alt="メニューの矢印" />
                      </span>
                    </Link>
                  </div>
                  <ul className="hamburger-menu__item02">
                    {item.subItems.map(subItem => (
                      <li key={subItem.label}>
                        <Link to={subItem.path}>{subItem.label}</Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : (
                <div className="hamburger-menu__item01" key={item.label}>
                  <div className="hamburger-menu__label">
                    <Link to={item.path} className="c_link_animation">
                      {item.label}
                      <span className="c_link_animation__arrow">
                        <img src={menu_arrow} alt="メニューの矢印" />
                      </span>
                    </Link>
                  </div>
                </div>
              )
            )}
            <div className="hamburger-menu__cv">
              <CvButton
                primaryLabel="今すぐ無料ではじめる"
                Color="Red"
                href="/get-started"
              />
              <CvButton
                primaryLabel="資料ダウンロード"
                Color="Navy"
                href="/download"
              />
            </div>
          </div>
        </div>
        <div className="header__cv"></div>
      </nav>
      <main className={`global__main `}>{children}</main>
      <footer className="footer">
        <div className="footer__wrapper">
          <div className="footer__container">
            <div className="footer__logo">
              <a
                href="https://corporate.demae-can.co.jp/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={logoImg} alt="出前館のロゴ" />
              </a>
            </div>
            <nav className="footer__nav">
              <ul className="footer__nav_head">
                <li>
                  <a
                    href="https://corporate.demae-can.co.jp/company/profile.html"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    企業情報
                    <span className="footer__nav_head-icon"></span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://service.demae-can.co.jp/gig_personal/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    配達員募集
                    <span className="footer__nav_head-icon"></span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://recruit.demae-can.co.jp/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    採用情報
                    <span className="footer__nav_head-icon"></span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://developer.demae-can.com/?utm_source=restaurantsite&utm_content=footer"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    加盟店さま向けAPIドキュメント
                    <span className="footer__nav_head-icon"></span>
                  </a>
                </li>
              </ul>
              <ul className="footer__nav_bottom">
                <li>
                  <a
                    href="https://corporate.demae-can.co.jp/inquiry/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    お問い合わせ
                    <span className="footer__nav_bottom-icon"></span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://corporate.demae-can.co.jp/securitypolicy.html"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    情報セキュリティ方針
                    <span className="footer__nav_bottom-icon"></span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://corporate.demae-can.co.jp/privacy.html"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    プライバシーポリシー
                    <span className="footer__nav_bottom-icon"></span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://corporate.demae-can.co.jp/socialmedia.html"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    ソーシャルメディアポリシー
                    <span className="footer__nav_bottom-icon"></span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://corporate.demae-can.co.jp/antisocial.html"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    反社会的勢力に関する基本方針
                    <span className="footer__nav_bottom-icon"></span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://demae-can.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    出前館
                    <span className="footer__nav_bottom-icon"></span>
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <div className="footer__copyright">
          <div className="footer__container">
            <div className="footer__contents">
              <div className="footer__sns">
                <a
                  href="https://twitter.com/demaecan"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={twitterIcon} alt="Twitter" />
                </a>
                <a
                  href="https://www.facebook.com/demaecan"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={facebookIcon} alt="Facebook" />
                </a>
                <a
                  href="https://www.instagram.com/demaecan_official/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={instagramIcon} alt="Instagram" />
                </a>
                <a
                  href="https://www.youtube.com/channel/UC7bR96_7zBvjVsrOiyuDqRQ"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={youtubeIcon} alt="YouTube" />
                </a>
              </div>
              <p className="footer__text">© Demae-can Co., Ltd.</p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default Layout
